var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcLandingEasy4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 385"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 284",
    cx: 25,
    cy: 41.5,
    rx: 8,
    ry: 8,
    fill: "#3A7EFC"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 285",
    cx: 25,
    cy: 6.5,
    rx: 6,
    ry: 6,
    fill: "#A9E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 342",
    d: "M0 31.9259C0 30.8213 0.892583 29.9224 1.99647 29.8837C4.92682 29.7809 10.2843 29.4274 12.5 28.2129C15.625 26.5 25 26.5 25 26.5C25 26.5 34.375 26.5 37.5 28.2129C39.7157 29.4274 45.0732 29.7809 48.0035 29.8837C49.1074 29.9224 50 30.8213 50 31.9259V38.5C50 39.6046 49.1046 40.5 48 40.5H2C0.895432 40.5 0 39.6046 0 38.5V31.9259Z",
    fill: "#A9E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 343",
    d: "M7 20.5C7 12.768 13.268 6.5 21 6.5H28C35.732 6.5 42 12.768 42 20.5V37.5H7V20.5Z",
    fill: "#A9E2FF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLandingEasy4);
export default __webpack_public_path__ + "static/media/IcLandingEasy4.4f8fc5b229167f537b2e8e93c34256ce.svg";
export { ForwardRef as ReactComponent };